"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosInterceptor = void 0;
const _1 = require(".");
class AxiosInterceptor {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    getAuthInterceptor() {
        return new _1.AuthInterceptor(this.axiosInstance);
    }
    getCacheInterceptor(storage) {
        return new _1.AxiosCacheInterceptor(this.axiosInstance, storage);
    }
    getDuplicateInterceptor() {
        return new _1.AxiosDuplicateInterceptor(this.axiosInstance);
    }
    getErrorInterceptor() {
        return new _1.AxiosErrorInterceptor(this.axiosInstance);
    }
    getLoadingInterceptor(onRequestStart, onRequestEnd) {
        return new _1.AxiosLoadingInterceptor(this.axiosInstance, onRequestStart, onRequestEnd);
    }
    getLoggerInterceptor() {
        return new _1.AxiosLoggerInterceptor(this.axiosInstance);
    }
    getQueueInterceptor() {
        return new _1.AxiosQueueInterceptor(this.axiosInstance);
    }
    getRefreshTokenInterceptor(config) {
        return new _1.AxiosRefreshTokenInterceptor(this.axiosInstance, config);
    }
    getResponseInterceptor() {
        return new _1.AxiosResponseInterceptor(this.axiosInstance);
    }
    getRetryInterceptor(config) {
        return new _1.AxiosRetryInterceptor(this.axiosInstance, config);
    }
}
exports.AxiosInterceptor = AxiosInterceptor;
//# sourceMappingURL=AxiosInterceptor.js.map